import { useReduxState } from 'hooks';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  onlyForAdmin?: boolean;
  onlyForSuperadmin?: boolean;
  title: string;
}

const UpdatesListItem = ({
  children,
  onlyForAdmin,
  onlyForSuperadmin,
  title
}: Props) => {
  const { user } = useReduxState();

  if (onlyForAdmin && user?.roles.includes('superadmin')) return null;
  if (onlyForSuperadmin && !user?.roles.includes('superadmin')) return null;

  return (
    <div className="list-item">
      <div className="title">{title}</div>
      <div className="content">{children}</div>

      <style jsx>{`
        .list-item {
          position: relative;
          padding-left: 20px;
        }
        .list-item::before {
          content: '•';
          font-size: 2.4rem;
          line-height: 0;
          position: absolute;
          top: 9px;
          left: 3px;
        }
        .list-item:not(:first-child) {
          margin-top: 15px;
        }
        .title {
          font-weight: 700;
        }
        .content {
          margin-top: 5px;
          line-height: 1.5;
        }
        .content :global(p) {
          margin: 0 0 5px;
        }
        .content :global(ul) {
          margin: 10px 0;
          padding-left: 15px;
        }
        .content :global(ul > li) {
          margin: 3px 0;
        }
      `}</style>
    </div>
  );
};

export default UpdatesListItem;
